<template>
  <v-dialog class="modal" v-model="internal">
    <v-card class="px-5">
      <v-card-actions class="d-flex justify-space-between">
        <v-card-title>{{ $t('newPortModal.title') }}</v-card-title>
        <v-btn icon @click="internal = false"
          ><v-icon small>mdi-close</v-icon></v-btn
        >
      </v-card-actions>
      <v-card-actions
        v-if="!selectedInput.overview"
        class="d-flex flex-column align-end w-100"
      >
        <div class="new-portfolio">
          <div class="d-flex align-start flex-column">
            <span class="strong mb-5">{{ $t('newPortModal.portfolioName') }}</span>
            <v-text-field
              :rules="[(v) => !!v || $t('instructions.uploadFiles.obligatory')]"
              dense
              v-model="selectedInput.selectedName"
              outlined
              :label="$t('newPortModal.enterPortfolioName')"
            >
            </v-text-field>
          </div>

          <div class="d-flex align-start flex-column">
            <span class="strong mb-5">{{ $t('newPortModal.baseCurrency') }}</span>
            <v-select
              outlined
              :rules="[(v) => !!v || $t('instructions.uploadFiles.obligatory')]"
              dense
              label=""
              :items="requiredCurrency"
              v-model="selectedInput.selectedCurrency"
            ></v-select>
          </div>

          <div class="d-flex align-start flex-column">
            <span class="strong mb-5">{{ $t('newPortModal.portfolioDate') }}</span>
            <v-menu
            v-model="selectedInput.menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  dense
                  v-model="selectedInput.selectedDate"
                  :label="$t('newPortModal.selectDate')"
                  prepend-inner-icon="mdi-calendar-blank"
                  readonly
                  :rules="[(v) => !!v || $t('instructions.uploadFiles.obligatory')]"
                  outlined
                  v-bind="attrs"
                  v-on="on"
                >
                </v-text-field>
              </template>
              <v-date-picker
                v-model="selectedInput.selectedDate"
                @input="selectedInput.menu = false"
              ></v-date-picker>
            </v-menu>
          </div>
        </div>
        <v-divider></v-divider>
        <div>
          <base-button class="mr-2" @click="internal = false">{{ $t('instructions.cancel') }}</base-button>
          <base-button @click="nextPage">{{ $t('instructions.next') }}</base-button>
        </div>
      </v-card-actions>

      <div v-else>
        <v-card-actions class="d-flex justify-space-between">
          <div>
            <h3>{{ $t('newPortModal.portfolioName') }}</h3>
            <h4>{{ selectedInput.selectedName }}</h4>
          </div>

          <div>
            <h3>{{ $t('newPortModal.baseCurrency') }}</h3>
            <h4>{{ selectedInput.selectedCurrency }}</h4>
          </div>

          <div>
            <h3>{{ $t('newPortModal.portfolioDateCaps') }}</h3>
            <h4>{{ selectedInput.selectedDate }}</h4>
          </div>
        </v-card-actions>
        <v-divider class="my-4"></v-divider>
        <v-card-actions class="d-flex flex-column">
          <div class="position-cta">
            <h3>{{ $t('dVolt.positions') }}</h3>
            <base-button v-if="maxLines < 64" :isDisable="maxLines > 64" @click="addPosition">+ {{ $t('newPortModal.addPosition') }}</base-button>
            <p id="error-lines" v-else-if="maxLines > 64">{{ $t('newPortModal.maxLinesError') }}</p>
          </div>
          <div class="overview-table">
            <div class="table-row header">
              <h4>{{ $t('quoteInfo.status') }}</h4>
              <h4>{{ $t('newPortModal.symbols') }}</h4>
              <h4>{{ $t('newPortModal.contractsShares') }}</h4>
              <h4>{{ $t('newPortModal.aggregationLabels') }}</h4>
              <h4>{{ $t('broker.clientPortfolio.headers.actions') }}</h4>
            </div>

            <div class="table-row" v-for="(pos, i) in positions" :key="i">
              <v-chip
                :class="
                  !pos.symbol || !pos.quantity ? 'error-input' : 'valid-input'
                "
                class="mb-5 mx-auto px-5"
                >{{ !pos.symbol || !pos.quantity ? $t('newPortModal.error') : $t('newPortModal.valid') }}</v-chip
              >
              <v-text-field
                :label="$t('newPortModal.egSymbol')"
                v-model="pos.symbol"
                outlined
                dense
              ></v-text-field>
              <v-text-field
                :label="$t('newPortModal.egQuantity')"
                v-model="pos.quantity"
                outlined
                dense
              ></v-text-field>
              <v-text-field
                :label="$t('newPortModal.egLabel')"
                outlined
                v-model="pos.label"
                dense
              ></v-text-field>
              <v-btn icon @click="deleteRow(pos.id)"
                ><v-icon color="red">mdi-close</v-icon></v-btn
              >
            </div>
          </div>
          <div class="cta-end d-flex justify-space-between">
            <div>
              <base-button @click="selectedInput.overview = false">
                {{ $t('instructions.back') }}
              </base-button
            >
            </div>
            <div>
              <base-button class="mr-2" @click="internal = false">{{ $t('instructions.cancel') }}</base-button>
              <base-button isActive @click="createPortfolio"
                >{{ $t('newPortModal.createPortfolio') }}</base-button
              >
            </div>
          </div>
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "ImportModal",
  props: {
    value: { type: Boolean, default: false },
  },
  data() {
    // ID FILE csv_${Date.now()}_${Math.random().toString(36).slice(2,8)}`
    return {
      selectedInput: {
        menu: false,
        selectedName: null,
        selectedCurrency: null,
        selectedDate: null,
        overview: false,
        selectedSymbols: null,
        selectedContracts: null,
      },
      positions: [
        {
          id: null,
          symbol: null,
          quantity: null,
          aggregationLabel: null,
          avgCost: null,
        },
      ],
      requiredCurrency: [
        `USD - ${this.$t('newPortModal.currencies.usd')}`,
        `EUR - ${this.$t('newPortModal.currencies.eur')}`,
        `GBP - ${this.$t('newPortModal.currencies.gbp')}`,
        `CAD - ${this.$t('newPortModal.currencies.cad')}`,
      ],
      headerItems: [
        { text: "Status", value: "status" },
        { text: "Symbols", value: "symbols" },
        { text: "Contracts/Shares", value: "contract" },
        { text: "Aggregation Labels", value: "aggregationLabel" },
        { text: "Actions", value: "actions" },
      ],
    };
  },
  computed: {
    internal: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
    today() {
      return new Date().toLocaleDateString("en-US");
    },
    maxLines()
    {
      return this.positions.length;
    }
  },
  methods: {
    nextPage() {
      if (
        this.selectedInput.selectedCurrency === null ||
        this.selectedInput.selectedDate === null ||
        this.selectedInput.selectedName === null
      ) {
        return;
      } else {
        this.selectedInput.overview = true;
      }
    },
    addPosition() {
      this.positions.push({
        id: Math.floor(Math.random() * 1000) + 1,
        symbol: null,
        name: null, //TODO fetch based on ticker symbol
        avgCost: null, // TODO fetch based on company dauly price
        currency: this.selectedInput.selectedCurrency,
        quantity: null,
        aggregationLabel: null,
      });
    },
    formatDate(date) {
    if (!date) return null;
    const [y, m, d] = date.split("-");
    return `${m}/${d}/${y}`;
  },
    deleteRow(id) {
      this.positions = this.positions.filter((p) => p.id !== id);
    },
    createPortfolio() {
      //needs to have the same style as store
      const newPortfolio = [
        {
          currency: this.selectedInput.selectedCurrency.split(" ")[0],
          id: Math.random().toString(36).substr(2, 9),
          date: this.formatDate(this.selectedInput.selectedDate) || this.today,
          name: this.selectedInput.selectedName,
          positions: this.positions,
          quantity: this.positions.length,
        },
      ];
      this.$emit("new-portfolio", newPortfolio);
      this.internal = false;
    },
  },
  watch: {
    internal(v) {
      if (!v) {
        this.selectedInput = {
          menu: false,
          selectedName: null,
          selectedCurrency: null,
          selectedDate: null,
          overview: false,
          selectedSymbols: null,
          selectedContracts: null,
        };
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = null; // clears file input
        }
      }
    },
  },
};
</script>

<style scoped>

.v-card {
  margin: auto;
  max-width: 70vw !important;
  border-radius: 10px;
}

.file-name {
  border: 1px solid white;
  padding: 0.3rem 1rem;
  width: 60%;
  border-radius: 3px;
}
.upload-files {
  cursor: pointer;
  border: 3px dashed white;
  border-radius: 10px;
  width: 100%;
  padding-top: 3rem;
  padding-bottom: 4rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}

.upload-files h5 {
  font-weight: 400 !important;
}

.new-portfolio {
  gap: 1rem;
  display: flex;
  width: 100%;
  flex-direction: row;
}

.new-portfolio > div {
  flex: 1;
  min-width: 0;
}

.new-portfolio .v-text-field,
.new-portfolio .v-select,
.new-portfolio .v-menu {
  width: 100%; /* force full width */
}

.v-data-table {
  width: 100% !important;
  border: 1px solid white;
  border-radius: 15px;
  padding: 1rem;
}

.position-cta {
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 2rem;
}
.cta-end {
  display: flex;
  gap: 1rem;
  width: 100%;
  margin-top: 2rem;
  justify-content: flex-end;
}

.overview-table {
  display: grid;
  gap: 1.5rem;
}
.table-row {
  display: grid;
  grid-template-columns: 1fr 2fr 2fr 2fr auto;
  justify-content: center;
  gap: 1.5rem;
}
.valid-input
{
  background-color: rgba(38,194,129, .4 )!important; /*success*/
  border:1px solid var(--success) !important;
  color: var(--success) !important;
  font-weight: 600;
}

.error-input{
    background-color: rgba(229,83,83, .4 )!important; /*danger*/
  border:1px solid var(--danger) !important;
  color: var(--danger) !important;
  font-weight: 600;

}

#error-lines
{
  color: var(--danger);
}
</style>